export interface ApiErrorShape {
  message?: string;
  raw?: unknown;
}

/**
 * Extracts a user-friendly error message from an API error object.
 * Handles structured validation errors ({ raw.fields }) returned by the backend.
 */
export const getErrorMessage = (
  apiError: ApiErrorShape | null | undefined,
  fallback = "Something went wrong",
): string => {
  const raw    = apiError?.raw as { fields?: Record<string, string | null | undefined> } | undefined;
  const fields = raw?.fields;
  if (fields && typeof fields === "object") {
    const messages = Object.values(fields).filter(Boolean) as string[];
    if (messages.length > 0) return messages.join(", ");
  }
  return apiError?.message ?? fallback;
};
